import {useGrpcRequestCallback} from '@aboutyou/data-fetcher';
import {NewsletterSubscriptionService_SubscribeToWhatsappNewsletterLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/newsletter_subscription/v1/service.grpc.lazy';
import {useTranslation} from '@aboutyou/i18n';
import {Log} from '@aboutyou/mlm';
import {useHistory, useQueryParamsCallback} from '@aboutyou/router';
import {useShowToast} from '@aboutyou/ui-components';

export const UUID_QUERY_PARAM_KEY = 'e_waChannelUser';
const COUNTRY_CODE_QUERY_PARAM_KEY = 'countryCode';

export const useWhatsappParams = () => {
  const getQueryParams = useQueryParamsCallback();
  const newSearch = new URLSearchParams(getQueryParams());
  const whatsappUUIDToken = newSearch.get(UUID_QUERY_PARAM_KEY);
  const countryCode = newSearch.get(COUNTRY_CODE_QUERY_PARAM_KEY);
  const {location, replace} = useHistory();

  const removeWhatsappQueryParams = () => {
    const searchparams = new URLSearchParams(getQueryParams());
    searchparams.delete(UUID_QUERY_PARAM_KEY);
    searchparams.delete(COUNTRY_CODE_QUERY_PARAM_KEY);
    replace({
      ...location,
      search: searchparams.toString(),
    });
  };

  return {
    whatsappUUIDToken,
    countryCode,
    removeWhatsappQueryParams,
  };
};

export const useSubscribeToWhatsappNewsletter = () => {
  const {t} = useTranslation();
  const showToast = useShowToast();
  const {removeWhatsappQueryParams} = useWhatsappParams();

  const onSuccess = () => {
    removeWhatsappQueryParams();

    showToast({
      type: 'SUCCESS',
      content: t(
        'Great! You are now successfully registered to receive notifications on WhatsApp.',
      ),
      'data-testid': 'subscribeToWhatsappNewsletterToastSuccess',
    });
  };

  const onError = (error: Error) => {
    Log.error(
      '@aboutyou/logic-components',
      'useSubscribeToWhatsappNewsletter',
      {
        error,
      },
    );

    showToast({
      type: 'WARNING',
      content: t(
        'Oops! Something went wrong while trying to register you for WhatsApp notifications. Please try again later.',
      ),
      'data-testid': 'subscribeToWhatsappNewsletterToastError',
    });
  };

  const grpcRequestCallback = useGrpcRequestCallback(
    NewsletterSubscriptionService_SubscribeToWhatsappNewsletterLazy,
  );

  const subscribeToWhatsappNewsletterCallback = (
    customerSessionToken: string,
    whatsappToken: string,
    externalCountryCode: string,
  ) => {
    grpcRequestCallback({
      session: {
        authToken: customerSessionToken,
      },
      whatsappToken,
      externalCountryCode,
    })
      .then(onSuccess)
      .catch(onError);
  };

  return subscribeToWhatsappNewsletterCallback;
};
